import { v4 } from 'uuid';

/**
 * Generates a cryptographically secure v4 UUID
 * @returns A valid v4 UUID string
 */
function uuidv4(): string {
  return v4();
}

export { uuidv4 };
